import styled from "styled-components";
import Lottie from "lottie-react";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;

export const SnackBar = styled.div`
  height: 50px;
  margin-bottom: 10px;
`;

export const QuizRule = styled.div`
  position: absolute;
  top: 305px;
  text-align: center;
  background-color: #e49b0f;
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 40px;
  padding-right: 40px;
  margin-left: 25px;
  margin-right: 25px;
  font-size: 16px;
  font-weight: 500;
  color: yellow;
`;
export const CreditMsgDiv = styled.div`
  color: #ffc000;
  padding-left: 20px;
  max-width: 380px;
  padding-right: 20px;
  text-align: center;
  margin-top:8px;
  font-size: 10px;
`;
